import React from "react";

export const cellStyle = {
    padding: '0px 0px 0px 10px',
}

export const releaseColumn = {
}

export const severityColumn = {
}

export const getLinkButtonStyle = (statusSort) => {
    switch(statusSort) {
        case 0: 
            return {
                color: '#2874A6',
                textDecoration: 'underline',
                fontSize: '1rem',
                borderRadius: '12px',
                backgroundColor: '#FDEDEC'
            }
        case 1:
            return {
                color: '#2874A6',
                textDecoration: 'underline',
                fontSize: '1rem',
                borderRadius: '12px',
                backgroundColor: '#FEF9E7'

            }
        case 2: 
            return {
                color: '#2874A6',
                textDecoration: 'underline',
                fontSize: '1rem',
                borderRadius: '12px',
                backgroundColor: '#EAFAF1',
                letterSpacing: '0.5px'

            }
        default:
    }
}

export const updatedStyle = {
    whiteSpace: 'normal',
    label: {
        whiteSpace: 'normal'
    }
}

export const getColumnStyle = (label) => {
    switch(label) {
        case 'status':
            return {
                padding: '0px 5px 0px 10px',
                textAlign: 'right'
            }
        case 'number':
            return {
                padding: '0px 0px 0px 0px',
                textAlign: 'center',
            }
        case 'title':
            return {
                padding: '0px 0px 0px 5px',
                textAlign: 'left',
                fontSize: '1rem'

            }
        case 'severity':
            return {
                padding: '0px 0px 0px 5px',
                textAlign: 'center'

            }
        case 'created':
            return {
                padding: '0px 0px 0px 5px',
                textAlign: 'center'

            }
        case 'updated':
            return {
                padding: '0px 0px 0px 5px',
                textAlign: 'center'

            }
        case 'assignment':
            return {
                padding: '0px 0px 0px 5px',
                textAlign: 'center'

            }
        case 'release':
            return {
                padding: '0px 0px 0px 5px',
                textAlign: 'center'

            }
        default:
    }
}


// TODO: pass in username
export const getAssignmentStyle = (assigneeLabel) => {
    const currentLogin = localStorage.getItem('db-login');
    switch (assigneeLabel === currentLogin) {
        case true:
            return {
                background: '#AED6F1'
            }
        case false:
            return {
                background: '#F2F4F4'
            };
        default:
    }
}

export const getSevStyle = (severityLabel) => {
    switch (severityLabel) {
        case 'SEV0':
            return {
                backgroundColor: '#F5B7B1'
            }
        case 'SEV1':
            return {
                backgroundColor: '#EDBB99'
            }
        case 'SEV2':
            return {
                backgroundColor: '#FAD7A0'
            }
        case 'SEV3':
            return {
                backgroundColor: '#F9E79F'
            }
        case 'SEV4':
            return {
                backgroundColor: '#FEF9E7'
            }
        default:
            // return {
            //     color: 'grey'
            // }
    }
}

export const getReleaseStyle = (releaseLabel, currentRelease) => {
    switch (releaseLabel === currentRelease) {
        case true:
            return {
                background: '#D2B4DE'
            }
        case false:
            return {
                background: '#F2F4F4'
            };
        default:
    }
}



export const getStatusIcon = (sortValue) => {
    switch(sortValue) {
        case 0:
            return (
                <img src={'https://s3-us-west-2.amazonaws.com/dj-icons/statusClosed.svg'} alt=''/>
            )
        case 1:
            return (
                <img src={'https://s3-us-west-2.amazonaws.com/dj-icons/statusBlocked.svg'} alt=''/>
            )
        case 2:
            return (
                <img src={'https://s3-us-west-2.amazonaws.com/dj-icons/statusOpen.svg'} alt=''/>
            )
        default:
    }
}

export const getEmptyStyle = () => {
    return {
        textAlign: 'center',
        padding: '0px',
        fontSize: '0.5rem'
    }
}


// WEBPACK FOOTER //
// ./src/js/styles/TableCell_Styles.js